import { NavigationItem } from '@10d/tend-ui-header';
import { Submenu } from '../types';

export const sortMenu = (menu: Submenu<NavigationItem>[], order: string[]) => {
  const keyOrder: { [key: string]: number } = {};

  // Build compound key map
  order.forEach((key, index) => {
    const parts = key.split('/');
    for (let i = 1; i <= parts.length; i++) {
      const compoundKey = parts.slice(0, i).join('/');
      keyOrder[compoundKey] = index;
    }
  });

  menu.sort((a, b) => keyOrder[a.key as string] - keyOrder[b.key as string]);

  function sortSubMenu(submenu: Submenu<NavigationItem>[]) {
    return submenu.sort((a, b) => keyOrder[a.key as string] - keyOrder[b.key as string]);
  }

  menu.forEach(item => {
    if (item.children) {
      item.children = sortSubMenu(item.children as Submenu<NavigationItem>[]);
    }
  });

  return menu;
};
